import { render, staticRenderFns } from "./DownloadDocumentsModal.vue?vue&type=template&id=3f996d97&"
import script from "./DownloadDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./DownloadDocumentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports